import React, { useState, useEffect } from 'react';
import { isMobile, isBrowser } from 'react-device-detect';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ButtonNormal from '../../Buttons/ButtonNormal';
import moment from 'moment';
import Payment from './components/Payment';
import styled from 'styled-components';

const dropDown = '/img/drop-down-2.svg';


const List = styled.div`
  border-top: 1px solid #e7e7e7;
`;

const PageButton = styled.button`
  margin: 24px 0;
  background-color: transparent;
  cursor: pointer;
  outline: none;
  border: none;
  line-height: normal;
  font-weight: bold;
  color: #10587f;
  display: flex;
  -webkit-tap-highlight-color: transparent;
`;

const StyledTableCell = withStyles({
  head: {
    backgroundColor: 'white',
    color: '#484848',
    fontWeight: 'bold',
    borderBottom: '0.5px solid #c1c1c1',
  },
  body: {
    fontSize: 14,
    fontWeight: (props) => (props.fontWeight ? props.fontWeight : 'normal'),
    color: (props) => (props.color ? props.color : '#484848'),
    fontStyle: (props) => (props.fontStyle ? props.fontStyle : 'normal'),
    borderBottom: 'none',
  },
})(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(even)': {
      backgroundColor: '#f5f5f5',
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  tableContainer: {
    boxShadow: 'none',
  },
  table: {
    minWidth: 700,
  },
});

const History = ({membershipData, membershipType}) => {
  const classes = useStyles();
  const screenMd = useMediaQuery('(max-width: 959px)');

  const changeWord= (word)=>{
    let text;
    switch(word) {
  case 'active':
    text = "activo";
    break;
  case 'past_due':
    text = "pasadod";
    break;
  case 'unpaid':
    text = "no pagado";
    break;
  case 'canceled':
    text = "cancelado";
    break;
  case 'incomplete':
    text = "incompleto";
    break;
  case 'incomplete_expired':
    text = "incompleto expirado";
    break;
  case 'trialing':
    text = "juicio";
    break;
  case 'draft':
    text = "espera";
    break;
  case 'open':
    text = "abierto";
      break;
  case 'succeeded':
    text = "Exitoso";
      break; 
  default:
   text = "proceso";
    }
    return text;
  }

  /* Format amount */
function currencyFormat(num) {
  return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

//console.log(numberFormat.format(amount));
 
  return  (
    <div style={{ maxWidth: 880, margin: screenMd? 0 : '0 40px', }}>
      {!screenMd && (
        <TableContainer
          component={Paper}
          classes={{ root: classes.tableContainer }}
        >
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center" padding="default">
                  Fecha
                </StyledTableCell>
                <StyledTableCell align="left">Pago</StyledTableCell>
                <StyledTableCell align="left">No. Referencia </StyledTableCell>
                <StyledTableCell align="left">Membresía</StyledTableCell>
                <StyledTableCell align="left">Total</StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {membershipData &&  membershipData.payments && membershipData.payments.length && membershipData.payments.map((row) => (
                <StyledTableRow key={row.invoice}>
                  <StyledTableCell align="center" padding="default">
                  {moment.unix(row.created).utc().format('DD/MM/YYYY')}

                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    color={row.status === 'succeeded' ? '#6ecc47' : '#d74242'}
                    fontWeight={row.status === 'Fallido' ? 'bold' : 'normal'}
                    fontStyle={row.status === 'Pendiente' ? 'italic' : 'normal'}
                  >
                    {changeWord(row.status)}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                  {row.number ? row.number : 'Procesando'}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                  {membershipType}
                  </StyledTableCell>
                  <StyledTableCell align="left">{currencyFormat(parseInt(row.amount.toString().slice(0,-2)))}</StyledTableCell>
                  <StyledTableCell align="center">
                    {row.status === 'succeeded' ? (
                     <a style={{textDecoration:'none'}} href={row.receipt_url} target='_blank' rel="noopener noreferrer">
                      <ButtonNormal
                        variant="secondaryOutlined"
                        style={{
                          width: 96,
                          height: 32,
                          maxWidth: 'unset',
                          minWidth: 'unset',
                        }}
                      >
                        Recibo
                      </ButtonNormal>
                      </a> 
                    ) : (
                      <a style={{textDecoration:'none'}} href={row.receipt_url} ><ButtonNormal
                        variant="primary"
                        style={{
                          width: 96,
                          height: 32,
                          maxWidth: 'unset',
                          minWidth: 'unset',
                        }}
                      >
                        Pagar
                      </ButtonNormal>
                      </a>
                    )}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {screenMd && (
        <>
          <List>
            {membershipData &&  membershipData.payments && membershipData.payments.length && membershipData.payments.map((item) => (
              <Payment
                key={item.invoice}
                payment={item}
                membershipType={membershipType}
              />
            ))}
          </List>
          {membershipData &&  membershipData.payments && membershipData.length > 15 && (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <PageButton>
                Ver más <img src={dropDown} alt="drop up" />
              </PageButton>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default History;
